import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { ONBOARDING_DOCUMENTS } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const getOnboardingDocumentById = async (data = array()) => {
    try {
        const url = data?.Id
            ? `${ONBOARDING_DOCUMENTS.LIST}/${data?.Id}`
            : ONBOARDING_DOCUMENTS.LIST;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const addOnboardingDocument = async (data = array()) => {
    try {
        const response = await POST(ONBOARDING_DOCUMENTS.LIST, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const updateOnboardingDocument = async (id, data = array()) => {
    try {
        const url = `${ONBOARDING_DOCUMENTS.LIST}/${id}`;
        const response = await PUT(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const fetchOnboardingDocumentTableAndFilterSchema = async (data = array()) => {
    try {
        const url = data?._Id
            ? `${ONBOARDING_DOCUMENTS.METADATA}/${data?._Id}`
            : ONBOARDING_DOCUMENTS.METADATA;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const submitOnboardingDocumentFilterData = async (data = array()) => {
    try {
        const response = await POST(ONBOARDING_DOCUMENTS.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
